"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const AutomaticGearbox = (props) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "icon icon-tabler icons-tabler-outline icon-tabler-automatic-gearbox", ...props },
    React.createElement("path", { d: "M0 0h24v24H0z", stroke: "none" }),
    React.createElement("path", { d: "M17 17v4h1a2 2 0 100-4h-1zM17 11h1.5a1.5 1.5 0 000-3H17v5M3 5a2 2 0 104 0 2 2 0 10-4 0" }),
    React.createElement("path", { d: "M5 7v3a1 1 0 001 1h3v7a1 1 0 001 1h3M9 11h4" }));
exports.default = AutomaticGearbox;
